import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { ContentSection } from "../Layout/ContentSection";
import { ContentSectionAlt } from "../Layout/ContentSectionAlt";
import { API_TagTag } from "../../../src/apidefs";
import { api } from "../api";
import { EntryList } from "../DesignSystem/EntryList";
import { Heading } from "../DesignSystem/formatting/Heading";
import { Subheading } from "../DesignSystem/formatting/Subheading";
import { deslugify } from "../models/tags";

type TagParams = {
  tag_slug: string;
};

export const TagExplorerPage = (): JSX.Element => {
  const { tag_slug: tagSlug } = useParams<TagParams>();
  const tag = deslugify(tagSlug);
  const [tagResults, setTagResults] = useState<API_TagTag>();

  useEffect(() => {
    let cancelled = false;

    const fetchTags = async () => {
      const result = await api.get<"/api/tag/:tag">(
        `/api/tag/${encodeURIComponent(tag)}`
      );
      if (!cancelled) {
        setTagResults(result);
      }
    };

    fetchTags();

    return () => {
      cancelled = true;
    };
  }, [tag]);

  if (!tagResults) {
    return <div> Loading! </div>;
  }

  return (
    <div>
      <ContentSection>
        <Heading>Tag explorer</Heading>

        <Subheading>
          Entries Tagged <strong>{tag}</strong>
        </Subheading>
      </ContentSection>

      <ContentSectionAlt>
        <EntryList
          entries={tagResults.entries}
          associatedCompos={tagResults.entries.map((entry) => ({
            compo_id: entry.compo_id,
            type: entry.compo_type,
            name: entry.name,
          }))}
        />
      </ContentSectionAlt>
    </div>
  );
};
